import { store } from '../store/store';

/**
 * Reset a user's password
 * @param {string} token - The reset token from the URL
 * @param {string} password - The new password
 */
const ResetPassword = async (token, password) => {
    const state = store.getState();
    const API_BASE = state.user.apiBase;

    try {
        const response = await fetch(`${API_BASE}/users/resetpassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token,
                password,
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
};

export default ResetPassword;
